import { render, staticRenderFns } from "./AverageCoursePricePerHourPanel.vue?vue&type=template&id=5e2d9dad&scoped=true"
import script from "./AverageCoursePricePerHourPanel.vue?vue&type=script&lang=js"
export * from "./AverageCoursePricePerHourPanel.vue?vue&type=script&lang=js"
import style0 from "./AverageCoursePricePerHourPanel.vue?vue&type=style&index=0&id=5e2d9dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d9dad",
  null
  
)

export default component.exports